export default {
  BLOCK_ID_PREFIX: 'ws-block',
  WIDGET_ID_PREFIX: 'ws-block-widget',
  ONLINE_STORE_BLOCK_ID: 'online-store',
};
